//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"Brightness",1,0],[0,"StationaryQuality",1,0]],[[[],"UpdateRayTracedDisplay",{},0,0],[[],"StartRayTracedDisplay",{},0,0],[[],"StopRayTracedDisplay",{},0,0],[[],"RayTracedPreferences",{},0,0],[[],"RayTracedEditor",{},0,1],[[],"RayTracedRenderingStart",{},0,0],[[],"RayTracedRenderingErase",{},0,0],[[],"RayTracedRenderingSave",{},0,0],[[],"RayTracedAnimationStart",{},0,0],[[],"RayTracedAnimationResume",{},0,0],[[],"RayTracedAnimationPause",{},0,0],[[],"RayTracedAnimationStop",{},0,0]],[]];
SPLM.Display.RayTracedStudioBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.RayTracedStudioBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.RayTracedStudioBuilder.StationaryDisplayQualityType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low"});

export default SPLM;